import {
  FETCH_EPG_MENU_ERROR,
  FETCH_EPG_MENU_SUCCESS,
  FETCH_EPG_MENU_INIT,
} from '../actions/epgMenu';

const initialState = {
  epgMenu: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EPG_MENU_INIT:
      return { ...state, epgMenu: null, error: null, success: false };
    case FETCH_EPG_MENU_SUCCESS:
      return { ...state, epgMenu: action.payload, error: null, success: true };
    case FETCH_EPG_MENU_ERROR:
      return { ...state, epgMenu: null, error: action.error, success: false };
    default:
      return state;
  }
};
